module.exports = __webpack_public_path__ + "static/functions-screen-6-7ed638c17937335b86657610089d2dff.png";